import { permissionsRol as licensesBatchRol } from 'app/policies/roles/licensesBatchRol.access';
import { PATH_LICENSE_BATCH_MONO, PATH_LICENSE_BATCH_MONO_CREATE, PATH_LICENSE_BATCHS_MONO } from 'app/router/routesConfigLicensesBatchMono';

export function licensesBatchMono({ flags, path, user }) {
  if (PATH_LICENSE_BATCHS_MONO === path) {
    return licensesBatchRol(user).readList && !!flags?.showLicenseMonoProgram;
  }

  if (PATH_LICENSE_BATCH_MONO_CREATE === path) {
    return licensesBatchRol(user).create && !!flags?.showLicenseMonoProgram;
  }

  if (PATH_LICENSE_BATCH_MONO === path) {
    return licensesBatchRol(user).readDetail && !!flags?.showLicenseMonoProgram;
  }

  return true;
}
